import 'reflect-metadata';

import axios, { AxiosInstance } from 'axios';
import { injectable } from 'inversify';

import {
  IRepositoryResponseValueObject,
  TRepositoryRequestParameters,
} from '../../../shared/abstract/infrastructrue/types';
import { AxiosDelegationStrategyEnum } from '../../../shared/core/domain/enums';
import { ValueObject } from '../../../shared/core/domain/ValueObject';

@injectable()
export abstract class ServiceClientAdapter {
  protected async handleRequest<T, K extends AxiosDelegationStrategyEnum>(
    payload: TRepositoryRequestParameters<T>,
  ): Promise<ValueObject<IRepositoryResponseValueObject<T>[K]>> {
    if (
      payload.parameters.strategy ===
      AxiosDelegationStrategyEnum.REACT_HOOK_DELEGATION
    ) {
      return <ValueObject<IRepositoryResponseValueObject<T>[K]>>(
        ValueObject.create(payload.parameters.config)
      );
    }

    const { data } = await this.withTransientAxiosInterceptors(payload)(
      payload.parameters.config,
    );

    return ValueObject.create(data);
  }

  private withTransientAxiosInterceptors = <T>(
    payload: TRepositoryRequestParameters<T>,
  ): AxiosInstance => {
    const transientAxiosInstance: AxiosInstance = axios.create({
      ...payload.parameters.config,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    transientAxiosInstance.interceptors.response.use((response) => {
      return Promise.resolve({
        ...response,
        data: payload.parameters.config.dtoAdapter(response.data),
      });
    });

    return transientAxiosInstance;
  };
}
